import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CallCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M9.79752 6.75H7.76973C7.47885 6.75 7.24221 6.98706 7.2502 7.27783C7.41899 13.4237 10.5763 16.581 16.7222 16.7498C17.0129 16.7578 17.25 16.5212 17.25 16.2303V14.2025C17.25 13.9943 17.1274 13.8057 16.9372 13.7212L15.155 12.9291C14.9846 12.8534 14.7867 12.8734 14.635 12.9818L13.764 14.1963C13.6143 14.3033 13.4183 14.3244 13.25 14.25C11.6264 13.5326 10.4674 12.3736 9.75 10.75C9.67563 10.5817 9.69672 10.3858 9.80368 10.236L11.0182 9.36502C11.1266 9.21325 11.1467 9.01544 11.0709 8.84499L10.2788 7.06277C10.1943 6.87258 10.0057 6.75 9.79752 6.75Z"
				fill="white"
			/>
		</svg>
	);
}

CallCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CallCircleFilledIcon;
